import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import {
  IUserPreferenceGeneralListItem,
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { useAppDispatch } from '@user/store/hooks'
import { useSelector } from 'react-redux'

export function useNoteFilterState() {
  const dispatch = useAppDispatch()
  const [sortBy, setSortBy] = useState<string>('NEW')
  const [showPestPacNote, setPestPacNotesShow] = useState<boolean>(false)
  const [showKnockStatusNote, setShowKnockStatusNotes] = useState<boolean>(true)

  const userGeneralPreferences: IUserPreferenceGeneralListItem[] = useSelector(
    userGeneralPreferencesList,
  )

  useEffect(() => {
    const execute = async () => {
      try {
        const sortPreferences = userGeneralPreferences.filter(
          (item) =>
            item.type === IUserPreferenceGeneralListItemType.NoteViewSortOrder,
        )

        const pestPacOnPreferences = userGeneralPreferences.filter(
          (item) =>
            item.type === IUserPreferenceGeneralListItemType.NoteViewPestPacOn,
        )
        const knockStatusOnPreferences = userGeneralPreferences.filter(
          (item) =>
            item.type ===
            IUserPreferenceGeneralListItemType.NoteViewKnockStatusOn,
        )

        if (sortPreferences.length > 0) {
          setSortBy(sortPreferences[0].value)
        }
        if (pestPacOnPreferences.length > 0) {
          setPestPacNotesShow(pestPacOnPreferences[0].value === 'true')
        }
        if (knockStatusOnPreferences.length > 0) {
          setShowKnockStatusNotes(knockStatusOnPreferences[0].value === 'true')
        }
      } catch (error) {
        console.log(error)
      }
    }

    execute()
  }, [userGeneralPreferences])

  const onChangeSort = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setSortBy(event.target.value)
      dispatch(
        saveGeneralPreferences({
          type: IUserPreferenceGeneralListItemType.NoteViewSortOrder,
          value: event.target.value,
        }),
      )
    },
    [setSortBy, dispatch],
  )

  const onChangeShowPestPacNotes = useCallback(() => {
    setPestPacNotesShow(!showPestPacNote)
    dispatch(
      saveGeneralPreferences({
        type: IUserPreferenceGeneralListItemType.NoteViewPestPacOn,
        value: String(!showPestPacNote),
      }),
    )
  }, [showPestPacNote, dispatch])

  const onChangeShowKnockStatusNotes = useCallback(() => {
    setShowKnockStatusNotes(!showKnockStatusNote)
    dispatch(
      saveGeneralPreferences({
        type: IUserPreferenceGeneralListItemType.NoteViewKnockStatusOn,
        value: String(!showKnockStatusNote),
      }),
    )
  }, [showKnockStatusNote, dispatch])

  return {
    sortBy,
    showPestPacNote,
    showKnockStatusNote,
    onChangeSort,
    onChangeShowPestPacNotes,
    onChangeShowKnockStatusNotes,
  }
}
